<img src="../../../assets/img/blurred.jpg" style="z-index: -2;object-fit: cover;position: absolute;width: 100%;height: 90vh;">
<div class="heading" style=" text-align: center;line-height: 0.8;text-shadow: 2px 2px #0d4794; color: rgb(255, 255, 255);display: flex; justify-content: center;font-size: 2vw;font-weight:600;margin-top: 2%; margin-bottom: 2%;">TUT Online Orientation</div>

<div *ngIf="!stepTwo && !stepThree" class="container page-container" style="background-color: white;width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">

    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> Complete the form to register. </p>
        <!--<p style="padding-top: 5px; font-size: 13px;  text-align: center;"> Step 1/2 </p>-->
        <span *ngIf="error" (click)="removeError()">{{ error }}</span>
        <form>
            <div class="form-group">
                <label for="exampleInputEmail1">Student Number</label>
                <input type="email" maxlength="9" minlength="9" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" class="form-control" id="exampleInputStudNum" placeholder="Enter your student number" name="studNum" [(ngModel)]="studNum"
                    required>
                <!--<small style="color: red;">NB! Your student number will also be your student e-mail<br> it will look like 225489768@tut4life.ac.za</small>-->
            </div>
            <div class="form-group">
                <label for="exampleInputEmail1">First name</label>
                <input type="email" onkeypress="return /[a-z ]/i.test(event.key)" class="form-control" id="exampleInputFirstname" placeholder="Enter your first name" name="firstName" [(ngModel)]="firstName" required>
            </div>

            <div class="form-group">
                <label for="exampleInputEmail1">Last name</label>
                <input type="email" onkeypress="return /[a-z-]/i.test(event.key)" class="form-control" id="exampleInputLastname" placeholder="Enter your last name" name="lastName" [(ngModel)]="lastName" required>
            </div>

            <div class="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your email" name="email" [(ngModel)]="email" required>
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter your password" name="password" [(ngModel)]="password" required>
                <small style="color: red;"> Password must have atleast 6 characters = 1 special character, 1 UPPERCASE, 1 lowercase [&] 1 number</small>
            </div>
            <div class="form-group">
                <label for="exampleInputPassword1">Confirm Password</label>
                <input type="password" class="form-control" id="exampleInputPassword2" placeholder="Confirm your password" name="password" [(ngModel)]="password2" required>
            </div>
            <div>
                <label  for="Policy">Do you agree to our Privacy & Cookies Policy &nbsp; </label>
                <input style="border-style:solid" type="checkbox" id="policy" name="policy" value="policy"[(ngModel)]="policy"> &nbsp;&nbsp;
                <a  style="color: blue; font-weight: 800;cursor: pointer;"  (click)="readPolicy()"> read more </a>
            </div>
            <button type="submit" style="margin-left: 35%; margin-top: 7%;margin-bottom: -9%;" class="btn btn-primary" (click)="sendOTP()">Register</button>
        </form>

    </div>
</div>

<div *ngIf="stepThree" class="container page-container" style="background-color: white;width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">
    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> We value your privacy </p>
        <p style="padding-top: 5px; font-size: 13px;  text-align: center;font-weight:800"> South Africa’s Protection of Personal Information Act (POPIA) & Cookie Consent </p>
        <span *ngIf="error" (click)="removeError()">{{ error }}</span>
        <form>


            <div class="form-group">
                <p>
                    We will not sell, share, or rent your Personal Information to any third party
                    or use your email address for unsolicited mail. Any emails sent by us will only
                    be in connection with the provision of authanticating your email.
                    We use cookies on our website to collect your names and later use it for your certificate. By clicking “ACCEPT ALL”, you consent to the use of ALL the cookies</p>
                    <div style="text-align: center;">
                        <a style="color: #0d4794; font-weight:800; " target=”_blank” href="https://popia.co.za/"> TO READ MORE ABOUT THE POPIA CLICK HERE</a>
                    </div>
            </div>

            <a type="submit" style="margin-left: 35%; margin-top: 7%;margin-bottom: -9%; color: antiquewhite;" class="btn btn-primary" (click)="back()">Go back</a>
        </form>

    </div>
</div>

<div *ngIf="stepTwo" class="container page-container" style="background-color: white;width: 30rem;border-radius: 25px;margin-top: 2%;box-shadow: 10px 24px 70px -18px rgba(0, 0, 0, 0.32);">
    <div style="width:70%;margin-left: 15%;">

        <p style="padding-top: 15px; font-weight: bold; font-size: 17px;  text-align: center;"> Complete the form to register. </p>
        <p style="padding-top: 5px; font-size: 13px;  text-align: center;"> Step 2/2 </p>
        <span *ngIf="error" (click)="removeError()">{{ error }}</span>
        <form>


            <div class="form-group">
                <label for="exampleInputEmail1">One Time Pin</label>
                <input type="text" maxlength="6" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" class="form-control" id="otp" aria-describedby="emailHelp" placeholder="Enter OTP" name="otp" [(ngModel)]="otpField" required>
                <small style="color:red;" id="emailHelp">
                    <br>To access your student email
                    <a style="font-weight: bold;" href="https://outlook.office.com/mail" target="_blank">Click here</a>
                </small>
            </div>

            <button type="submit" style="margin-left: 35%; margin-top: 7%;margin-bottom: -9%;" class="btn btn-primary" (click)="register()">Register</button>
        </form>

    </div>
</div>
